import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, TextField, TextFieldProps } from '@mui/material';
import * as React from 'react';

type PasswordProps = TextFieldProps & { testId?: string };
export const PasswordField: React.FC<PasswordProps> = ({ testId, ...props }) => {
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <TextField
      autoComplete={props.autoComplete || 'new-password'}
      {...props}
      type={showPassword ? 'text' : 'password'}
      slotProps={{
        htmlInput: {
          'data-testid': testId,
        },
        input: {
          endAdornment: (
            <IconButton onClick={() => setShowPassword(!showPassword)} sx={{ padding: 0 }}>
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          ),
        },
      }}
    />
  );
};
